export const initialFilter = {
  userId: 1
};

export const mainInfo = [
  {
    id: 1,
    key: 'username',
    options: {
      allowCopy: true,
      allowEdit: true,
    }
  },
  {
    id: 2,
    key: 'phone',
    options: {
      allowCopy: true,
      allowEdit: true,
      keyName: 'phoneNumber',
    }
  },
  {
    id: 3,
    key: 'email',
    options: {
      allowCopy: true,
      allowEdit: true,
      clickableItem: true
    }
  },
  {
    id: 4,
    key: 'receiveNotifications',
    options: {
      allowEdit: true,
      inputType: 'bool',
    }
  },
  {
    id: 5,
    key: 'notificationsTimestamp',
    options: {
      allowCopy: false,
      allowEdit: false,
      inputType: 'date',
    }
  },
];

export const personalInfoKeys = [
  {
    id: 5,
    key: 'idNumber',
    options: {
      allowCopy: true,
      allowEdit: true,
    }
  },
  {
    id: 7,
    key: 'city',
    options: {
      allowCopy: true,
      allowEdit: true,
    }
  },
  {
    id: 71,
    key: 'street',
    options: {
      allowCopy: true,
      allowEdit: true,
    }
  },
  {
    id: 72,
    key: 'houseNum',
    options: {
      allowCopy: true,
      allowEdit: true,
    }
  },
  {
    id: 73,
    key: 'appartmentNum',
    options: {
      allowCopy: true,
      allowEdit: true,
    }
  },
  {
    id: 8,
    key: 'agentId',
    options: {
      allowCopy: true,
      allowEdit: true,
    }
  },
  {
    id: 9,
    key: 'tamalId',
    options: {
      allowCopy: true,
      allowEdit: true,
    }
  },
  {
    id: 10,
    key: 'createdAt',
    options: {
      allowCopy: true,
    }
  },
  {
    id: 11,
    key: 'mainCategoryIdText',
    options: {
      allowCopy: true,
      allowEdit: true,
      inputType: 'dropdown',
      keyName: 'mainCategoryId',
      ddType: 'main_category_items',
    }
  },
  {
    id: 12,
    key: 'genderText',
    options: {
      allowCopy: true,
      allowEdit: true,
      inputType: 'dropdown',
      keyName: 'gender',
      ddType: 'gender_items',
    }
  },
  {
    id: 13,
    key: 'citizenshipText',
    options: {
      allowCopy: true,
      allowEdit: true,
      inputType: 'dropdown',
      keyName: 'citizenship',
      ddType: 'citizenship_items',
    }
  },
  {
    id: 14,
    key: 'birthDate',
    options: {
      allowCopy: true,
      allowEdit: true,
      inputType: 'date',
    }
  },
  {
    id: 15,
    key: 'kupatHolimText',
    options: {
      allowCopy: true,
      allowEdit: true,
      inputType: 'dropdown',
      keyName: 'kupatHolim',
      ddType: 'kupat_holim_items',
    }
  },
  {
    id: 16,
    key: 'familyStatusText',
    options: {
      allowCopy: true,
      allowEdit: true,
      inputType: 'dropdown',
      keyName: 'familyStatus',
      ddType: 'family_status_items',
    }
  },
  {
    id: 17,
    key: 'dateOfAliyah',
    options: {
      allowCopy: true,
      allowEdit: true,
      inputType: 'date',
    }
  },
  {
    id: 18,
    key: 'liveOutsideIsrael',
  },
  {
    id: 19,
    key: 'partnerFirstName',
    options: {
      allowCopy: true,
      allowEdit: true,
    }
  },
  {
    id: 20,
    key: 'partnerLastName',
    options: {
      allowCopy: true,
      allowEdit: true,
    }
  },
  {
    id: 21,
    key: 'otherIncomeExists',
  },
  {
    id: 22,
    key: 'freelanceStartDate',
    options: {
      allowCopy: true,
      allowEdit: true,
      inputType: 'date',
    }
  },
  {
    id: 23,
    key: 'monthlyAverageIncome',
    options: {
      allowCopy: true,
      allowEdit: true,
    }
  },
  {
    id: 24,
    key: 'weeklyAverageWorkHoursText',
    options: {
      allowCopy: true,
      allowEdit: true,
      inputType: 'dropdown',
      keyName: 'weeklyAverageWorkHours',
      ddType: 'week_average_hours_items',
    }
  },
  {
    id: 25,
    key: 'approveAdvertisement',
  },
  {
    id: 26,
    key: 'approvePension',
  },
  {
    id: 27,
    key: 'approveInsurance',
  },
  {
    id: 28,
    key: 'affiliateCompanyID',
    options: {
      allowCopy: true,
      allowEdit: true,
      inputType: 'dropdown',
      keyName: 'affiliateCompanyID',
      ddType: 'affiliate_company_items',
    }
  },
  {
    id: 29,
    key: 'cameFrom',
    options: {
      allowCopy: false,
      allowEdit: false,
    }
  },
  {
    id: 30,
    key: 'cameFromText',
    options: {
      allowCopy: false,
      allowEdit: false,
    }
  }
];

export const bankInfoKeys = [
  {
    id: 1,
    key: 'bankNameText',
    options: {
      allowCopy: true,
      allowEdit: true,
      inputType: 'dropdown',
      ddType: 'bank_items',
      keyName: 'bankName'
    }
  },
  {
    id: 2,
    key: 'branchNum',
    options: {
      allowCopy: true,
      allowEdit: true,
    }
  },
  {
    id: 3,
    key: 'accountNum',
    options: {
      allowCopy: true,
      allowEdit: true,
    }
  },
  {
    id: 4,
    key: 'checkOnly',
    options: {
      allowEdit: true,
      inputType: 'bool',
    }
  },
];

export const practiceDataKeys = [
  {
    id: 1,
    key: 'practiceAreaText',
    options: {
      allowCopy: true,
    }
  },
  {
    id: 2,
    key: 'jobText',
    options: {
      allowCopy: true,
    }
  },
  {
    id: 3,
    key: 'scopeOfWorkText',
    options: {
      allowCopy: true,
    }
  },
  {
    id: 4,
    key: 'areaText',
    options: {
      allowCopy: true,
    }
  },
  {
    id: 5,
    key: 'clientsText',
    options: {
      allowCopy: true,
    }
  },
];
